import { gql } from 'urql'

export const fetchProcessCommitteeConfigSorted = gql`
  query fetchProcessCommitteeConfigSorted($committeeWhereClause: committee_config_bool_exp!) {
    committee_config(where: $committeeWhereClause, order_by: [{ sort_number: asc }]) {
      id
      sort_number
      active
      processes
      descriptions
    }

    committee_config_aggregate(where: $committeeWhereClause, order_by: [{ sort_number: asc }]) {
      aggregate {
        count
      }
    }
  }
`

export const queryCommitteeConfigById = gql`
  query ($committeeId: Int!) {
    committee_config(where: { id: { _eq: $committeeId } }) {
      id
      descriptions
      active
      processes
    }
  }
`

export const updateSortOnCommitteeConfig = gql`
  mutation UpdateTwoCommitteeOrder(
    $firstWhere: committee_config_bool_exp!
    $secondWhere: committee_config_bool_exp!
    $setClause1: committee_config_set_input!
    $setClause2: committee_config_set_input!
  ) {
    updateFirst: update_committee_config(where: $firstWhere, _set: $setClause1) {
      affected_rows
    }
    updateSecond: update_committee_config(where: $secondWhere, _set: $setClause2) {
      affected_rows
    }
  }
`

export const queryHighestCommitteeConfigSortNumber = gql`
  query {
    committee_config_aggregate {
      aggregate {
        max {
          sort_number
        }
      }
    }
  }
`

export const insertCommitteeConfig = gql`
  mutation ($committeeConfigInsertInput: [committee_config_insert_input!]!) {
    insert_committee_config(objects: $committeeConfigInsertInput) {
      affected_rows
    }
  }
`

export const updateCommitteeConfigById = gql`
  mutation ($id: Int!, $input: committee_config_set_input!) {
    update_committee_config(where: { id: { _eq: $id } }, _set: $input) {
      affected_rows
    }
  }
`
